import { render } from "./ExpenseGoupNewModalPopup.vue?vue&type=template&id=622928a6&scoped=true"
import script from "./ExpenseGoupNewModalPopup.vue?vue&type=script&lang=js"
export * from "./ExpenseGoupNewModalPopup.vue?vue&type=script&lang=js"

import "./ExpenseGoupNewModalPopup.vue?vue&type=style&index=0&id=622928a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622928a6"]])

export default __exports__